import React, { useEffect, useState } from "react";
import { FormControl } from "react-bootstrap";
import { Link } from "react-router-dom";
import { ReactComponent as RadioButtonChecked } from "../assets/icons/radio_button_checked.svg";
import { ReactComponent as RadiButtonUnchecked } from "../assets/icons/radio_button_unchecked.svg";
import { getTimeExpr } from "../utils";

export default function ChatClients(props) {
  const { clients, messages, recipientSelectHandler } = props;
  const [name, setName] = useState();
  const [clientsFiltered, setClientsFiltered] = useState(clients);

  const genFilteredClients = (name, clients, setClientsFiltered) => {
    if (name) {
      setClientsFiltered(
        clients
          .map((c) => ({ ...c, online: isClientOnline(c) }))
          .map((client) => {
            const unreadCount = messages?.filter(
              (m) => m.user.id === client._id && !m.read
            ).length;
            return { ...client, unread: unreadCount };
          })
          .filter(
            (c) =>
              c.name.toLowerCase().includes(name.toLowerCase()) ||
              c.businessName.toLowerCase().includes(name.toLowerCase())
          )
          .sort((a, b) =>
            (a.online && b.online) || (!a.online && !b.online)
              ? new Date(b.lastSeen) - new Date(a.lastSeen)
              : a.online && !b.online
              ? 1
              : -1
          )
      );
    } else {
      setClientsFiltered(
        clients
          .map((c) => ({ ...c, online: isClientOnline(c) }))
          .map((client) => {
            const unreadCount = messages?.filter(
              (m) => m.user.id === client._id && !m.read
            ).length;
            return { ...client, unread: unreadCount };
          })
          .sort((a, b) =>
            (a.online && b.online) || (!a.online && !b.online)
              ? new Date(b.lastSeen) - new Date(a.lastSeen)
              : a.online && !b.online
              ? -1
              : 1
          )
      );
    }
  };

  useEffect(() => {
    genFilteredClients(name, clients, setClientsFiltered, messages);
    const interval = setInterval(() => {
      genFilteredClients(name, clients, setClientsFiltered, messages);
    }, 1000 * 30);

    return () => clearInterval(interval);
  }, [clients, setClientsFiltered, name, messages]);

  const isClientOnline = (client) => {
    return (
      client.lastSeen &&
      new Date(client.lastSeen) - new Date(new Date() - 60000 * 1) > 0
    );
  };

  return (
    <div style={{ paddingBottom: "5px" }}>
      <FormControl
        value={name}
        style={{
          marginLeft: "30px",
          width: "300px",
        }}
        type="text"
        onChange={(e) => {
          setName(e.target.value);
        }}
        className="mb-2"
        placeholder="Kişi adı veya işletme adı ile arayın"
      ></FormControl>
      {clientsFiltered.map((client) => (
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            justifyContent: "flex-start",
            alignItems: "baseline",
          }}
          className="mb-2"
          key={client._id}
        >
          <div className="me-3">
            {client.online ? (
              <RadioButtonChecked width="16" fill="#2994b2" />
            ) : (
              <RadiButtonUnchecked width="14" fill="#6c757d" />
            )}
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              justifyContent: "flex-start",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                alignItems: "baseline",
              }}
            >
              <div
                style={{
                  fontSize: 16,
                  fontWeight: "bold",
                  marginRight: "13px",
                }}
              >
                <Link
                  to="#"
                  onClick={() => recipientSelectHandler(client)}
                  className={
                    client.online
                      ? "textDecorationNone text-success"
                      : "textDecorationNone text-dark"
                  }
                >
                  {client.name}
                </Link>
              </div>
              <div
                className="text-muted"
                style={{
                  fontSize: 14,
                  fontWeight: "bold",
                  marginRight: "13px",
                }}
              >
                {client.businessName}
              </div>
              {client.lastSeen && !client.online && (
                <div
                  className="text-muted"
                  style={{ fontSize: 11, marginRight: "13px" }}
                >
                  {getTimeExpr(new Date(client.lastSeen))}
                </div>
              )}
            </div>
            {client.unread > 0 && (
              <div
                style={{
                  fontSize: "15px",
                }}
              >
                <div className="text-danger">
                  {`${client.unread} yeni mesaj`}
                </div>
              </div>
            )}
          </div>
        </div>
      ))}
    </div>
  );
}
